import React from 'react'

const MySvgIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      fill='none'
      version='1.1'
      width='20'
      height='20'
      viewBox='0 0 20 20'
    >
      <defs>
        <clipPath id='master_svg0_70_5883'>
          <rect x='0' y='0' width='20' height='20' rx='0' />
        </clipPath>
      </defs>
      <g clipPath='url(#master_svg0_70_5883)'>
        <g>
          <path
            d='M17,17.7735L16.843,18.1847L11.99665,18.1847L8.40698,12.5611L7.66667,12.5611L7.66667,18.1847L3,18.1847L3,2L9.12499,2C13.388,2,15.4743,3.80578,15.4743,7.41779C15.4743,9.49803,14.5543,10.98389,12.87163,11.78406L17,17.7735ZM7.66667,5.72606L7.66667,9.08635L8.96804,9.08635C10.33673,9.08635,11.05431,8.53789,11.05431,7.41779C11.05431,6.29769,10.33628,5.72606,8.96804,5.72606L7.66667,5.72606Z'
            fillRule='evenodd'
            fill='#333333'
            fillOpacity='1'
            style={{ mixBlendMode: 'passthrough' }}
          />
        </g>
      </g>
    </svg>
  )
}

export default MySvgIcon
